__turbopack_context__.v({
  "buttonContainer": "VideoEmbed-module-scss-module__gu2ePG__buttonContainer",
  "customImageAndPlayButton": "VideoEmbed-module-scss-module__gu2ePG__customImageAndPlayButton",
  "image": "VideoEmbed-module-scss-module__gu2ePG__image",
  "playButton": "VideoEmbed-module-scss-module__gu2ePG__playButton",
  "root": "VideoEmbed-module-scss-module__gu2ePG__root",
  "setButtonCentered": "VideoEmbed-module-scss-module__gu2ePG__setButtonCentered",
  "video": "VideoEmbed-module-scss-module__gu2ePG__video",
  "videoDescription": "VideoEmbed-module-scss-module__gu2ePG__videoDescription",
});
